import { tiles } from '@/enums/colors.json';

export default {
  model: 'detailed',
  cards: {
    blue: { value: 'KÉK', color: tiles.blue, font: 'print-small' },
    green: { value: 'ZÖLD', color: tiles.green, font: 'print-small' },
    orange: { value: 'NARANCS', color: tiles.orange, font: 'print-small' },
    purple: { value: 'LILA', color: tiles.purple, font: 'print-small' },
    red: { value: 'PIROS', color: tiles.red, font: 'print-small' },
    yellow: { value: 'SÁRGA', color: tiles.yellow, font: 'print-small' }
  }
};
